<template>
  <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="demo-ruleForm"
  >
    <el-form-item label="" prop="name"
    ><el-input
        type="text"
        autocomplete="off"
        v-model="ruleForm.name"
        prefix-icon="el-icon-user-solid"
        placeholder="请输入用户名"
    ></el-input
    ></el-form-item>
    <el-form-item label="" prop="pass"
    ><el-input
        type="password"
        autocomplete="off"
        v-model="ruleForm.pass"
        prefix-icon="el-icon-lock"
        placeholder="请输入密码"
    ></el-input
    ></el-form-item>
    <el-form-item label="" prop="checkPass"
    ><el-input
        type="password"
        autocomplete="off"
        v-model="ruleForm.checkPass"
        prefix-icon="el-icon-lock"
        placeholder="请输入密码"
    ></el-input
    ></el-form-item>
    <el-form-item class="btns">
      <el-button type="primary" @click="submitForm('ruleForm')">注册</el-button>
      <el-button @click="resetForm('ruleForm')">重置</el-button>
      <el-button @click="get">测试</el-button>
    </el-form-item>
    <el-button class="btnclass"  :type="primary" link @click="btnclick001">已有账号？去登录</el-button>
  </el-form>
</template>

<script>

//import '/src/utils/axios.js'

import axios from 'axios'


export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };

    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      activeName: "second",
      ruleForm: {
        name: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入您的名称", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        pass: [{ required: true, validator: validatePass, trigger: "blur" }],
        checkPass: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('注册成功=')
          /* this.$message({
            type: "success",
            message: "注册成功",
          }); */
          //get();
           //this.activeName= 'first'
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    btnclick001(){
      //this.activeName='first';
      this.$emit("add",'first'); //触发事件
    },
    get(){
      
      let url ='http://47.98.194.29/api/user/register';
      let apiKey = '2WshDvM3a8682c1238af5a34f4eece5319e5a5637618bb7';
      let json = {
        user_name:'admin',
        user_pwd:'123456'
      }
      console.log('555666',JSON.stringify(json));

     // let url = 'https://yesno.wtf/api';
      
      axios.get(url).then(res => {
          console.log('99988',res);
          //this.data = res.data;
          
        })
        },

  },
};
</script>
<style scoped lang="less">
.btns {
  display: flex;
  justify-content: flex-end;
}.btnclass{
    margin-left: 270px;
    margin-top: 7px;
  }
</style>
